import _ from "underscore";
import templateUrl from 'emun.salesrep/salesrep-sales-category.htm'
import productSalesPopup from "emun.salesrep/product-sales-popup";
import salesrepConfig from 'emun.salesrep/salesrep.config'

class SalesRepSalesCategoryController {
  constructor($window, $rootScope, createAutoQuery, utils) {
    let $ctrl = this;
    $ctrl.utils = utils;
    //        $ctrl.mode = "list";
    if (!$ctrl.mode) { $ctrl.mode = 'list'; }
    $ctrl.total = 0;
    $ctrl.colors = salesrepConfig.chartColors;
    $ctrl.chartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.labels[tooltipItem.index];
            let datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "  (" + Math.round(((datasetLabel / $ctrl.total) * 100)) + '%)';
          }
        }
      },
    }
    var context = $ctrl.context || 'rep';

    var filterType = "SalesRepID";
    var repFilter = "";
    if (context !== 'executive') {
      if (context === 'manager') {
        filterType = 'ManagerId';
      }
      repFilter = "&" + filterType + "=" + $ctrl.rep.id;
    }

    var url = 'QuerySalesDailyCategoryTotals.json?Sum=SalesDailyTotal&GroupBy=Category&OrderBy=Category&dateRange=YTD' + repFilter;
    var lyurl = 'QuerySalesDailyCategoryTotals.json?Sum=SalesDailyTotal&GroupBy=Category&OrderBy=Category&dateRange=LYTD' + repFilter;

    $ctrl.categories = createAutoQuery({
      url: 'QueryProductCategories.json',
      take: 100,
      pageSize: 100,
      orderBy: 'Label',
      autoLoad: true,
      onLoaded: function (args) {
        $ctrl.categoryTotals = createAutoQuery({
          url: url,
          take: 100,
          pageSize: 100,
          autoLoad: true,
          onLoaded: function (totals) {
            $ctrl.chartLabels = [];
            $ctrl.chartData = [];
            totals.results.forEach(function (total) {
              args.results.forEach(function (c) {
                if (c.id.toUpperCase() === total.category.toUpperCase()) {
                  $ctrl.chartLabels.push(c.id);
                  $ctrl.chartData.push(Math.round(total.sumSalesDailyTotal));
                  $ctrl.total += total.sumSalesDailyTotal;
                  total.categpryName = c.label;
                }
              });
            });
            $ctrl.categoryTotalLY = createAutoQuery({
              url: lyurl,
              autoLoad: true,
              take: 100,
              pageSize: 100,
                  onLoaded: function (lytotals) {
                lytotals.results.forEach(function (lytotal) {
                  $ctrl.categoryTotals.results.forEach(function (c) {
                    if (c.category.toUpperCase() === lytotal.category.toUpperCase()) {
                      c.lytotal = lytotal.sumSalesDailyTotal;
                      c.diff = c.sumSalesDailyTotal - c.lytotal;
                      var percent = Math.round((c.sumSalesDailyTotal / c.lytotal) * 100);
                      if (percent < 100) {
                        c.percent = 100 - percent;
                        c.trend = 'down';
                      } else if (percent > 100) {
                        c.percent = percent - 100;
                        c.trend = 'up';
                      } else {
                        c.percent = 100;
                        c.trend = 'neutral';
                      }
                    }
                  });
                });
              }
            });
          }
        });
      }
    })
  }
  showCategoryDetails(category) {
    let $ctrl = this;
    return productSalesPopup({
      context: $ctrl.context,
      category: category,
      rep: $ctrl.rep,
      title: category + " Product Sales"
    }).then(function () {
      return;
    });
  }
  downloadData() {
    let $ctrl = this;
    var itemsFormatted = [];

    var headers = {
      name: 'Category',
      LYTD: "YTD",
      YTD: "LYTD",
      Diff: "Diff",
      Percent: "Percent"
    };

    // format the data
    $ctrl.categoryTotals.results.forEach((item) => {
      itemsFormatted.push({
        name: item.category.replace(/,/g, ''), // remove commas to avoid errors,
        YTD: item.sumSalesDailyTotal,
        LYTD: item.lytotal,
        Diff: item.diff,
        Percent: item.percent
      });
    });

    var fileTitle = 'salesrep-sales-category';
    $ctrl.utils.exportCSVFile(headers, _.sortBy(itemsFormatted, 'YTD').reverse(), fileTitle);
  }
}

let SalesRepSalesCategory = {
  bindings: {
    rep: '<',
    repGroup: '@',
    context: '@'
  },
  controller: SalesRepSalesCategoryController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default SalesRepSalesCategory